<template>
  <div class="playlet">
    <el-card>
      <el-input
        v-model="name"
        placeholder="请输入推广名称"
        style="width: 400px;margin-bottom: 10px;"
      ></el-input>
      <div>
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
          :row-key="rowKey"
          max-height="550"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            align="center"
            width="55"
            :reserve-selection="true"
          />
          <el-table-column
            prop="name"
            label="名称"
            width="300"
            align="center"
          />
          <el-table-column
            prop="app_id"
            label="appId"
            width="200"
            align="center"
          />
          <el-table-column
            prop="app_id"
            label="封面"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.url"
                :fit="'cover'"
                :preview-src-list="[`${scope.row.url}`]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_at_text"
            label="创建时间"
            align="center"
          />
        </el-table>
      </div>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <div>
      <el-button
        type="primary"
        @click="sendgo"
        style="margin-top: 20px;"
      >生成</el-button>
    </div>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { gameSettinglist, officialAccountgenerate } from '@/api/sourceminiprogram.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      parameter: {
        page: 1,
        page_size: 10
      },
      loading: false,
      tableData: [],
      total: null,
      cookiedialogVisible: false,
      selectlist: [],
      app_id: '',
      targets: [],
      name: ''
    }
  },

  created() {
    // this.getDatas()
  },
  activated() {
    // this.getDatas()
  },
  mounted() {},
  methods: {
    rowKey(row) {
      return row.id
    },
    async getDatas() {
      this.loading = true
      const data = await gameSettinglist(this.parameter)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
    },
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.getDatas()
    },

    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getDatas()
    },
    handleSelectionChange(rows) {
      this.selectlist = rows //
    },
    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10
      }
      this.getDatas()
    },

    updatar() {
      this.cookiedialogVisible = false
      this.getDatas()
    },
    sendgo() {
      console.log(this.selectlist)
      if (this.name === '') {
        this.$message.error('请输入推广名称')
        return
      }
      if (this.selectlist.length === 0) {
        this.$message.error('请选择要生成地址的小程序')
        return
      }
      this.targets = []
      this.targets = this.selectlist.map(item => {
        return item.app_id
      })
      officialAccountgenerate({
        targets: this.targets,
        name: this.name,
        app_id: this.app_id
      }).then(res => {
        this.$emit('updatalink')
        this.$message({
          message: '生成地址成功',
          type: 'success'
        })
      })
    },
    send(app_id) {
      this.app_id = app_id
      this.getDatas()
    }
  }
}
</script>

<style scoped>
.playlet {
  margin: 30px;
  width: 95%;
  margin: 0 auto;
}
.el-card {
  margin-top: 20px;
}
.selectionArea {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  flex-basis: calc(25% - 10px);
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}

.button-group {
  flex-basis: 100%; /* 按钮组占据一整行宽度 */
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box-card {
  height: 70px;
}
</style>

